import BaseModelAPI from '../BaseModelAPI';

export default class ProductionStandarTime extends BaseModelAPI {
	static entity = 'productionstandartime';
	static entityName = 'productionstandartime';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.standarTimeName = '';
			this.standarTimeCategoryId = '';
			this.standarTimeCategory = {};
			this.remark = '';
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}